export const colors = {
    Cover: {
        background: '#FFF6DF',
        spine: '#450025',
        left: '#FFF6DF',
        right: '#CFA8D9',
        primary_text: '#AA003D',
        secondary_text: '#450025',
    },
    Preface: {
        background: '#FF008A',
        spine: '#FF008A',
        left: '#FFDDEF',
        right: '#FCF1E8',
        primary_text: '#2FEA00',
        secondary_text: 'black',
    },
    Projects: {
        background: '#FF6060',
        spine: '#FF6060',
        left: 'black',
        right: '#60F3BD',
        primary_text: '#60F3BD',
        contrast: '#AD00FF', 
    },
    Contact: {
        background: '#450025',
        spine: '#450025',
        left: '#82CBFF',
        right: '#82CBFF',
        primary_text: 'white',
    }
};